<!-- =========================================================================================
    File Name: VerifyEmailPage.vue
    Description: Verify Email Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img v-if="setVerifyEmailPageImage" :src="img_cdn + setVerifyEmailPageImage" alt="login" class="mx-auto">
            </div>


            <div v-if="verifyPin" class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Enter Pin Code!</h4>
                  <p class="mb-4">An email has been sent with pin code kindly check your email to activate your account.</p>
                  <!--                  <p>Your are re.</p>-->
                </div>
                <div v-on:keyup.enter="submitData">
                  <vs-input
                    v-validate="'numeric|required|min:6|max:6|'"
                    name="pin"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Pin Code"
                    v-model="pinCode"
                    autofocus
                    class="w-full"/>

                  <span class="text-danger text-sm" v-show="errors.has('pin')">{{ errors.first('pin') }}</span>

                  <br>
                  <br>
                  <p v-if="invalidToken">Your email not confirmed try again please!</p>
                  <router-link to="/resend-confirmation-email">
                    <vs-button class="float-left" type="border">Resend again</vs-button>
                  </router-link>
                  <vs-button class="float-right" :disabled="!validateForm" @click="submitData">Activate</vs-button>
                  <br>
                </div>
              </div>
            </div>

            <!--            EMAIL SUCCESSFULLY APPROVED-->
            <div v-if="varified" class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Email Confirmed Successfully!</h4>
                  <!--                  <p>Your are re.</p>-->
                </div>
                <div>
                  <p>You have successfully confimed your email !</p>
                  <br>
                  <router-link to="/login">
                    <vs-button class="float-right" type="border">Login</vs-button>
                  </router-link>
<!--                  <vs-button class="float-right" @click="submitData">Login</vs-button>-->
                  <br>
                </div>
              </div>
            </div>

<!--            EMAIL ALREADY APPROVED-->
            <div v-if="alreadApproved" class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Registered successfully!</h4>
                </div>
                <div>
                  <p>You have registered successfully. Your account is under review. You will be able to login, once, it is approved</p>
                  <br>
                  <router-link to="/login">
                    <vs-button class="float-right" type="border">Login</vs-button>
                  </router-link>
<!--                  <vs-button class="float-right" @click="submitData">Login</vs-button>-->
                  <br>
                </div>
              </div>
            </div>




          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {GET_IMAGE_SETTING, VERIFY_EMAIL} from '@/graphql'


export default {
  data() {
    return {
      varified: false,
      invalidToken: false,
      pinCode: '',
      verifyPin: true,
      userEmail: '',
      alreadApproved: false,
      img_cdn:process.env.VUE_APP_IMAGES_CDN_LINK,
      setVerifyEmailPageImage:''

    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.pinCode !== ''
    }
  },
  methods: {

    submitData() {
      if(this.pinCode !=''){
      this.$apollo
        .mutate({
          mutation: VERIFY_EMAIL,
          variables: {
            token: this.pinCode,
            email: this.userEmail,
            pin_created_at: this.userPinTime,
          }
        })
        .then(response => {
          if (response.data.verifyEmail.status == 'SUCCESS') {
            this.varified = true
            this.invalidToken = false
            this.verifyPin = false
            this.alreadApproved = false
            // this.$router.replace('/login')
            this.SuccessStatus()
          } else if (response.data.verifyEmail.status == 'TOKEN_EXPIRE') {
            this.varified = false
            this.invalidToken = false
            this.alreadApproved = false
            this.verifyPin = true
            this.StatusExpire()
          } else if (response.data.verifyEmail.status == 'ALREADY_APPROVED') {
            this.varified = false
            this.invalidToken = false
            this.verifyPin = false
            this.alreadApproved = true
            // this.$router.replace('/login')
            this.emailAlreadyApprovedNotification()
          }
          else if (response.data.verifyEmail== null) {
            this.varified = false
            this.invalidToken = false
            this.verifyPin = false
            this.alreadApproved = false
            // this.$router.replace('/login')
            this.NotFoundNotification()
          }
        }) .catch(error => {
        this.varified=false
        this.invalidToken=true
        this.verifyPin=true
        this.alreadApproved = false
        this.NotFoundNotification()
      });
      }
    },
    SuccessStatus() {
      this.$vs.notify({
        title: "Email",
        text: 'Confirmed Successfully ',
        color: 'success',
        position: 'top-right'
      })

    },
    StatusInvalid() {

      this.$vs.notify({
        title: "Incorrect Data",
        text: 'Check and Enter again',
        color: 'danger',
        position: 'top-right'
      })
    },
    StatusExpire() {

      this.$vs.notify({
        title: "Token Expired",
        text: 'Your token has been expired',
        color: 'danger',
        position: 'top-right'
      })
    },
    emailAlreadyApprovedNotification() {
      this.$vs.notify({
        title: "Registered successfully",
        text: '',
        color: 'sucsess',
        position: 'top-right'
      })
    },
    NotFoundNotification() {
      this.$vs.notify({
        title: "Not Found",
        text: 'User Not Found',
        color: 'danger',
        position: 'top-right'
      })
    },

  },
  beforeCreate() {
    this.$apollo
      .query({
        query: GET_IMAGE_SETTING,
      })
      .then(response => {
        if (response.data.getImagesSetting.verify_email_page_image != null) {
          this.setVerifyEmailPageImage = response.data.getImagesSetting.verify_email_page_image
        }
      })
      .catch(error => {
        console.log(error)
      });
  },
  created() {

    this.userPinTime =  this.$route.params.pin_time
    if (this.$route.params.pin_time == undefined){
      this.userPinTime = localStorage.getItem('userPinTime')
    }
    // console.log(this.userPinTime)
  }

}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1
    }

    .bg-twitter {
      background-color: #00aaff
    }

    .bg-google {
      background-color: #4285F4
    }

    .bg-github {
      background-color: #333
    }
  }
}
</style>
